import React from 'react';

import { ILogout } from '@src/actions/auth';
import { SentinelUser } from '@modules/auth/components/types/user';
import Account from './Account';

type Props = {
  configurableUser: SentinelUser;
  logout: () => Promise<ILogout>;
  passwordChangeUrlClick: () => void;
  updateUser: (user: SentinelUser) => void;
};

const initialState = Object.freeze({});

type State = typeof initialState & {
  loadingError?: string;
};

class AccountsContainer extends React.PureComponent<Props, State> {
  readonly state: State = initialState;

  render() {
    const { configurableUser, logout, passwordChangeUrlClick, updateUser } = this.props;
    return (
      <Account
        configurableUser={configurableUser}
        logout={logout}
        passwordChangeUrlClick={passwordChangeUrlClick}
        updateUser={updateUser}
      />
    );
  }
}

export default AccountsContainer;
